import React from "react";
import dataFeatures from "../../data/About/about-corporate-business.json";
import FeatureBox from "../../elements/FeatureBox/FeatureBox";
import HeadingSection from "../HeadingSection/HeadingSection";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  row: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: 50,
    justifyContent: "space-between",
  },
  featureWrapper: {
    flexBasis: "30%",
    minWidth: 280,
    marginBottom: 24,
    display: "flex",
    flexDirection: "column",
  },
  text: {
    fontSize: "1.25rem",
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontWeight: 500,
    color: "black",
    lineHeight: 1.6,
    letterSpacing: "0.0075em",
  }
}));

const Features = ({ dark, id }) => {
  const classes = useStyles();

  return (
    <section className={"section" + (dark ? " section-dark" : "")}>
      <div className="container" id="section2">
        <HeadingSection title="Чому обирають City Brokers?" />
        <div className={classes.row}>
          {dataFeatures.map((feature) => (
            <div key={feature.id} className={classes.featureWrapper} >
              <FeatureBox icon={feature.icon} title={feature.title} iconColor="#d42e22">
                <div className={classes.text}>{feature.text}</div>
              </FeatureBox>
            </div>
          ))}
        </div>
        <p style={{color:'black'}}><b>City Brokers — це про страхування без зайвих слів. Про рішення, що працюють тоді, коли справді потрібно. Про спокій, який не відволікає, а підтримує.</b></p>
      </div>
    </section>
  );
};

export default Features;